<template>
  <div class="mt-5">
    <h3>Nytt passord</h3>
    <div class="text-muted mb-4">
      Angi din epost og ditt nye passord.
    </div>
    <b-alert :show="!!pageError" variant="danger">
      {{ pageError }}
    </b-alert>
    <div class="row">
      <div class="col-md-6">
        <b-form @submit.prevent="sendResetPassword">
          <b-form-group id="email" label="E-post adresse" label-for="email">
            <b-form-input
              id="email"
              v-model="form.email"
              type="email"
              required
              placeholder="e-post"
            ></b-form-input>
          </b-form-group>

          <b-form-group id="password" label="Nytt passord" label-for="password">
            <b-form-input
              id="password"
              v-model="form.password"
              required
              type="password"
              placeholder="passord"
            ></b-form-input>
          </b-form-group>
          <b-form-group id="password" label="Gjenta Nytt Passord" label-for="password">
            <b-form-input
              id="password"
              v-model="form.password_confirmation"
              required
              type="password"
              placeholder="passord"
            ></b-form-input>
          </b-form-group>
          <div
            class="invalid-feedback mt-2 mb-4"
            :style="{ display: authError ? 'block' : 'none' }"
          >
            Feil e-post eller passord
          </div>
          <b-button type="submit" variant="primary">
            Opprett nytt passord
          </b-button>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ResetPassword',
  mounted () {
    this.form.token = this.$route.query.token
  },
  computed: {
    ...mapGetters({ authError: 'auth/authStatus' }),
  },
  data () {
    return {
      pageError: null,
      form: {
        email: '',
        password: '',
        password_confirmation: '',
        token: null,
      },
    }
  },
  methods: {
    sendResetPassword () {
      this.$store.dispatch('auth/resetPassword', this.form).then(async () => {
        this.form.email = ''
        this.form.password = ''
        this.form.password_confirmation = ''

        this.$bvToast.toast(`Ditt nye passord er lagret. Klikk her for å logge inn.`, {
          variant: 'success',
          title: 'Vi har oppdatert ditt passord',
          autoHideDelay: 10000,
        })

        await this.$store.dispatch('auth/me')

        this.$router.push('/')
      }).catch(response => this.pageError = response.message)
    },
  },
}
</script>
